import { Play } from 'lucide-react';
import { resolveMediaUrl } from '../../../lib/mediaUrl';

export default function VideoLayerRenderer({ layer }) {
  const data = layer.data;

  if (!data.src) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center gap-2
                       bg-gray-800/60 border-2 border-dashed border-gray-600 rounded">
        <Play size={24} className="text-gray-500" />
        <span className="text-xs text-gray-500">No video source</span>
      </div>
    );
  }

  return (
    <video
      src={resolveMediaUrl(data.src)}
      poster={data.poster ? resolveMediaUrl(data.poster) : undefined}
      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      autoPlay={data.autoplay}
      loop={data.loop}
      muted={data.muted}
      playsInline
    />
  );
}
